<template>
  <div class="nx-list-page intelligent-abnormal-warn">
    <div class="warn-metrics">
      <div v-for="item in metrics" :key="item.label" class="metric-card" :class="item.className">
        <span>{{ item.label }}</span>
        <strong>{{ item.value }}</strong>
        <em>{{ item.extra }}</em>
      </div>
    </div>

    <div class="warn-panel">
      <el-form :inline="true" :model="query" size="small" class="warn-search">
        <el-form-item label="煤棚">
          <el-input v-model.trim="query.warehouseCode" clearable placeholder="请输入煤棚编码" />
        </el-form-item>
        <el-form-item label="堆位">
          <el-input v-model.trim="query.locationCode" clearable placeholder="请输入堆位编码" />
        </el-form-item>
        <el-form-item label="煤种">
          <el-input v-model.trim="query.varNo" clearable placeholder="请输入煤种编码" />
        </el-form-item>
        <el-form-item label="异常类型">
          <el-select v-model="query.warnType" clearable placeholder="全部">
            <el-option label="库存不足" :value="1" />
            <el-option label="超量存储" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item class="warn-search__actions">
          <el-button type="primary" icon="el-icon-warning-outline" :loading="loading" @click="handleDetect">
            手动检测
          </el-button>
          <el-button icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="warn-toolbar">
        <div class="warn-toolbar__title">
          <strong>异常库存列表</strong>
          <span>{{ tableTip }}</span>
        </div>
        <div class="warn-toolbar__actions">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-position"
            :disabled="!selectedRows.length"
            @click="openPushDialog"
          >
            选择人员推送
          </el-button>
          <el-button
            size="small"
            plain
            icon="el-icon-download"
            :loading="exportLoading"
            :disabled="!data.length"
            @click="exportCurrent"
          >
            导出当前页
          </el-button>
        </div>
      </div>

      <el-table
        ref="warningTable"
        v-loading="loading"
        :data="data"
        border
        stripe
        height="520"
        row-key="storeSubId"
        empty-text="请点击手动检测获取异常库存"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="48" align="center" />
        <el-table-column type="index" label="序号" width="70" align="center" :index="indexMethod" />
        <el-table-column label="异常类型" prop="warnType" width="110" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.warnType === 2 ? 'danger' : 'warning'" size="small">
              {{ formatWarnType(row.warnType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="煤棚" prop="warehouseName" min-width="130" show-overflow-tooltip />
        <el-table-column label="堆位" prop="locationName" min-width="130" show-overflow-tooltip />
        <el-table-column label="客户" prop="custName" min-width="150" show-overflow-tooltip />
        <el-table-column label="煤种" prop="varName" min-width="130" show-overflow-tooltip />
        <el-table-column label="当前库存(吨)" prop="currentInventory" min-width="120" align="right">
          <template slot-scope="{ row }">{{ formatNumber(row.currentInventory) }}</template>
        </el-table-column>
        <el-table-column label="容量上限(吨)" prop="capacityAmount" min-width="120" align="right">
          <template slot-scope="{ row }">{{ formatNumber(row.capacityAmount) }}</template>
        </el-table-column>
        <el-table-column label="容量占比" prop="capacityRate" min-width="160">
          <template slot-scope="{ row }">
            <div class="capacity-cell">
              <el-progress :percentage="toPercent(row.capacityRate)" :show-text="false" :stroke-width="8" />
              <span>{{ formatRate(row.capacityRate) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="触发规则" prop="thresholdSummary" min-width="190" show-overflow-tooltip />
        <el-table-column label="检测时间" prop="warnTime" width="160" align="center" />
        <el-table-column label="处置建议" prop="suggestion" min-width="240" show-overflow-tooltip />
      </el-table>

      <div class="warn-pagination">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="page.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-dialog
      title="选择推送人员"
      :visible.sync="pushDialogVisible"
      width="760px"
      append-to-body
      destroy-on-close
      :close-on-click-modal="false"
    >
      <div class="push-summary">
        已选择 <strong>{{ selectedRows.length }}</strong> 条异常信息，
        将通过系统消息通知推送给所选人员。
      </div>
      <el-input
        v-model.trim="userKeyword"
        class="user-filter"
        size="small"
        clearable
        prefix-icon="el-icon-search"
        placeholder="按姓名或账号筛选"
      />
      <el-table
        ref="userTable"
        v-loading="userLoading"
        :data="filteredUsers"
        border
        height="360"
        row-key="id"
        @selection-change="handleUserSelectionChange"
      >
        <el-table-column type="selection" width="48" align="center" />
        <el-table-column label="姓名" prop="realName" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.realName || row.name || "-" }}</template>
        </el-table-column>
        <el-table-column label="账号" prop="account" min-width="130" show-overflow-tooltip />
        <el-table-column label="部门" prop="deptName" min-width="180" show-overflow-tooltip />
      </el-table>
      <span slot="footer">
        <el-button size="small" @click="pushDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-position"
          :loading="pushLoading"
          :disabled="!selectedUsers.length"
          @click="confirmPush"
        >
          确认推送
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { export_json_to_excel } from "@/util/vendor/Export2Excel";
import { getUserList, manualDetect, pushWarning } from "./api";

export default {
  name: "automobile-intelligent-abnormal-warn",
  data() {
    return {
      loading: false,
      exportLoading: false,
      pushLoading: false,
      userLoading: false,
      hasDetected: false,
      query: {
        warehouseCode: "",
        locationCode: "",
        varNo: "",
        warnType: "",
      },
      page: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      data: [],
      stats: {},
      selectedRows: [],
      pushDialogVisible: false,
      userKeyword: "",
      users: [],
      selectedUsers: [],
    };
  },
  computed: {
    metrics() {
      return [
        { label: "异常总数", value: this.stats.total || 0, extra: "本次检测命中", className: "metric-card--danger" },
        { label: "库存不足", value: this.stats.lowStockCount || 0, extra: "库存量 <= 0", className: "metric-card--warning" },
        { label: "超量存储", value: this.stats.overStockCount || 0, extra: "库存量 > 容量上限", className: "metric-card--primary" },
        { label: "涉及煤棚", value: this.stats.storeCount || 0, extra: "按煤棚去重", className: "" },
      ];
    },
    tableTip() {
      if (!this.hasDetected) {
        return "点击手动检测后展示当前异常";
      }
      return `已检测到 ${this.page.total || 0} 条异常，可勾选后推送`;
    },
    filteredUsers() {
      const keyword = (this.userKeyword || "").toLowerCase();
      if (!keyword) {
        return this.users;
      }
      return this.users.filter((item) => {
        return [item.realName, item.name, item.account, item.deptName]
          .some((value) => String(value || "").toLowerCase().includes(keyword));
      });
    },
  },
  methods: {
    handleDetect() {
      this.page.currentPage = 1;
      this.loadWarnings();
    },
    handleReset() {
      this.query = {
        warehouseCode: "",
        locationCode: "",
        varNo: "",
        warnType: "",
      };
      this.page.currentPage = 1;
      this.data = [];
      this.stats = {};
      this.page.total = 0;
      this.hasDetected = false;
      this.selectedRows = [];
    },
    loadWarnings() {
      this.loading = true;
      const params = this.cleanParams({
        ...this.query,
        page: this.page.currentPage,
        size: this.page.pageSize,
      });
      manualDetect(params).then((res) => {
        if (res.data && res.data.success === false) {
          this.$message.error(res.data.msg || "检测失败");
          return;
        }
        const payload = (res.data && res.data.data) || {};
        this.data = payload.records || [];
        this.page.total = Number(payload.total || 0);
        this.stats = {
          total: payload.total || 0,
          lowStockCount: payload.lowStockCount || 0,
          overStockCount: payload.overStockCount || 0,
          storeCount: payload.storeCount || 0,
        };
        this.hasDetected = true;
        this.selectedRows = [];
        this.$nextTick(() => {
          this.$refs.warningTable && this.$refs.warningTable.clearSelection();
        });
        if (!this.page.total) {
          this.$message.info("未检测到库存异常");
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.page.currentPage = 1;
      if (this.hasDetected) {
        this.loadWarnings();
      }
    },
    handleCurrentChange(current) {
      this.page.currentPage = current;
      if (this.hasDetected) {
        this.loadWarnings();
      }
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows || [];
    },
    openPushDialog() {
      if (!this.selectedRows.length) {
        this.$message.warning("请先选择需要推送的异常信息");
        return;
      }
      this.pushDialogVisible = true;
      this.selectedUsers = [];
      this.$nextTick(() => {
        this.$refs.userTable && this.$refs.userTable.clearSelection();
      });
      if (!this.users.length) {
        this.loadUsers();
      }
    },
    loadUsers() {
      this.userLoading = true;
      getUserList({ status: 1 }).then((res) => {
        this.users = this.normalizeUserList(res.data);
      }).finally(() => {
        this.userLoading = false;
      });
    },
    normalizeUserList(payload) {
      if (Array.isArray(payload)) {
        return payload;
      }
      if (payload && Array.isArray(payload.data)) {
        return payload.data;
      }
      if (payload && payload.data && Array.isArray(payload.data.records)) {
        return payload.data.records;
      }
      if (payload && Array.isArray(payload.records)) {
        return payload.records;
      }
      return [];
    },
    handleUserSelectionChange(rows) {
      this.selectedUsers = rows || [];
    },
    confirmPush() {
      if (!this.selectedRows.length) {
        this.$message.warning("请先选择需要推送的异常信息");
        return;
      }
      if (!this.selectedUsers.length) {
        this.$message.warning("请先选择接收人员");
        return;
      }
      const payload = {
        storeSubIds: this.selectedRows.map((item) => item.storeSubId).filter(Boolean),
        warningItems: this.selectedRows,
        recipientUserIds: this.selectedUsers.map((item) => item.id).filter(Boolean),
      };
      this.pushLoading = true;
      pushWarning(payload).then((res) => {
        if (res.data && res.data.success === false) {
          this.$message.error(res.data.msg || "推送失败");
          return;
        }
        const result = (res.data && res.data.data) || {};
        if ((result.failCount || 0) > 0) {
          this.$message.warning(`推送完成，成功 ${result.successCount || 0} 人，失败 ${result.failCount || 0} 人`);
        } else {
          this.$message.success(`推送完成，成功 ${result.successCount || 0} 人`);
        }
        this.pushDialogVisible = false;
      }).finally(() => {
        this.pushLoading = false;
      });
    },
    exportCurrent() {
      if (!this.data.length) {
        this.$message.warning("无数据可导出");
        return;
      }
      this.exportLoading = true;
      try {
        const columns = [
          { label: "异常类型", prop: "warnType", formatter: (row) => this.formatWarnType(row.warnType) },
          { label: "煤棚", prop: "warehouseName" },
          { label: "堆位", prop: "locationName" },
          { label: "客户", prop: "custName" },
          { label: "煤种", prop: "varName" },
          { label: "当前库存(吨)", prop: "currentInventory", formatter: (row) => this.formatNumber(row.currentInventory) },
          { label: "容量上限(吨)", prop: "capacityAmount", formatter: (row) => this.formatNumber(row.capacityAmount) },
          { label: "容量占比", prop: "capacityRate", formatter: (row) => this.formatRate(row.capacityRate) },
          { label: "触发规则", prop: "thresholdSummary" },
          { label: "检测时间", prop: "warnTime" },
          { label: "处置建议", prop: "suggestion" },
        ];
        const header = columns.map((item) => item.label);
        const rows = this.data.map((row) => columns.map((item) => item.formatter ? item.formatter(row) : row[item.prop]));
        export_json_to_excel(header, rows, `异常库存预警_${Date.now()}`);
        this.$message.success("导出成功");
      } finally {
        this.exportLoading = false;
      }
    },
    cleanParams(params) {
      const result = {};
      Object.keys(params).forEach((key) => {
        if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
          result[key] = params[key];
        }
      });
      return result;
    },
    indexMethod(index) {
      return (this.page.currentPage - 1) * this.page.pageSize + index + 1;
    },
    formatWarnType(type) {
      if (Number(type) === 1) return "库存不足";
      if (Number(type) === 2) return "超量存储";
      return "-";
    },
    toPercent(value) {
      const num = Number(value || 0);
      if (!isFinite(num)) return 0;
      if (num < 0) return 0;
      if (num > 100) return 100;
      return Number(num.toFixed(2));
    },
    formatRate(value) {
      const num = Number(value || 0);
      if (!isFinite(num)) return "0.00%";
      return `${num.toFixed(2)}%`;
    },
    formatNumber(value) {
      const num = Number(value || 0);
      if (!isFinite(num)) return "0";
      return num.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
  },
};
</script>

<style scoped lang="scss">
.intelligent-abnormal-warn {
  .warn-metrics {
    display: grid;
    grid-template-columns: repeat(4, minmax(140px, 1fr));
    gap: 10px;
    margin-bottom: 12px;
  }

  .metric-card {
    min-height: 82px;
    padding: 14px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    box-sizing: border-box;

    span {
      display: block;
      margin-bottom: 9px;
      color: #64748b;
      font-size: 13px;
    }

    strong {
      display: block;
      color: #111827;
      font-size: 24px;
      line-height: 28px;
      font-weight: 700;
    }

    em {
      display: block;
      margin-top: 6px;
      color: #94a3b8;
      font-style: normal;
      font-size: 12px;
    }

    &--primary strong {
      color: #2563eb;
    }

    &--warning strong {
      color: #b45309;
    }

    &--danger strong {
      color: #dc2626;
    }
  }

  .warn-panel {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
  }

  .warn-search {
    padding: 14px 16px 2px;
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
  }

  .warn-search__actions {
    margin-right: 0;
  }

  .warn-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 50px;
    padding: 0 16px;
    box-sizing: border-box;
  }

  .warn-toolbar__title {
    display: flex;
    align-items: baseline;
    gap: 10px;

    strong {
      color: #111827;
      font-size: 15px;
    }

    span {
      color: #94a3b8;
      font-size: 12px;
    }
  }

  .warn-toolbar__actions {
    display: flex;
    gap: 8px;
  }

  .capacity-cell {
    display: grid;
    grid-template-columns: 1fr 58px;
    align-items: center;
    gap: 8px;
  }

  .warn-pagination {
    display: flex;
    justify-content: flex-end;
    padding: 10px 16px;
    border-top: 1px solid #ebeef5;
  }
}

.push-summary {
  margin-bottom: 10px;
  color: #606266;

  strong {
    color: #f56c6c;
  }
}

.user-filter {
  margin-bottom: 10px;
}

@media (max-width: 1200px) {
  .intelligent-abnormal-warn {
    .warn-metrics {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .warn-toolbar {
      align-items: stretch;
      flex-direction: column;
      gap: 10px;
      padding: 12px 16px;
    }

    .warn-toolbar__actions {
      justify-content: flex-end;
    }
  }
}

@media (max-width: 768px) {
  .intelligent-abnormal-warn {
    .warn-metrics {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }

    .warn-toolbar__title {
      display: block;

      span {
        display: block;
        margin-top: 4px;
      }
    }
  }
}
</style>
